const latestposts = [
  "/images/activities/catia-workshop.jpg",
  "/images/activities/visteon.jpg",
  "/images/activities/safran-visit.jpg",
];

export default latestposts;
